import React from 'react';
import { motion } from 'framer-motion';
interface PullQuoteProps {
  quote: string;
}
export function PullQuote({
  quote
}: PullQuoteProps) {
  return <motion.div className="max-w-3xl mx-auto px-6 py-8" initial={{
    opacity: 0,
    x: -20
  }} whileInView={{
    opacity: 1,
    x: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5
  }} data-id="element-165">
      <blockquote className="border-l-4 border-sage pl-6 italic font-lora text-xl md:text-2xl text-charcoal/80" data-id="element-166">
        "{quote}"
      </blockquote>
    </motion.div>;
}